import { createFileRoute } from '@tanstack/react-router';

import { DeviceSetupLandingPage } from 'src/apps/landingPages/app/pages/DeviceSetup';

export const Route = createFileRoute('/_public/landing-page/device-setup')({
  component: () => <DeviceSetupLandingPage />,
});
